import { clientApi2, get, post, remove } from '../../api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const IMPORT_CATALOG_CLEAR = 'IMPORT_CATALOG_CLEAR';
export const IMPORT_CATALOG_SET_CURRENT_STEP = 'IMPORT_CATALOG_SET_CURRENT_STEP';
export const IMPORT_CATALOG_SET_DETECT_BACK_STEP = 'IMPORT_CATALOG_SET_DETECT_BACK_STEP';
export const IMPORT_CATALOG_SET_FILE = 'IMPORT_CATALOG_SET_FILE';
export const IMPORT_CATALOG_SET_INFO_DATA = 'IMPORT_CATALOG_SET_INFO_DATA';
export const IMPORT_CATALOG_SET_OUTPUT_CONFIG = 'IMPORT_CATALOG_SET_OUTPUT_CONFIG';
export const IMPORT_CATALOG_SET_IMPORT_CONFIG = 'IMPORT_CATALOG_SET_IMPORT_CONFIG';
export const IMPORT_CATALOG_INIT_WORKER = 'IMPORT_CATALOG_INIT_WORKER';
export const IMPORT_CATALOG_SET_WORKER_STATUS = 'IMPORT_CATALOG_SET_WORKER_STATUS';
export const IMPORT_CATALOG_UPDATE_TABLE_DATA = 'IMPORT_CATALOG_UPDATE_TABLE_DATA';
export const IMPORT_CATALOG_UPDATE_PROGRESS = 'IMPORT_CATALOG_UPDATE_PROGRESS';
export const IMPORT_CATALOG_SET_XML_STRUCTURE = 'IMPORT_CATALOG_SET_XML_STRUCTURE';
export const IMPORT_CATALOG_SET_XML_PARSED_DATA = 'IMPORT_CATALOG_SET_XML_PARSED_DATA';
export const IMPORT_CATALOG_SET_XML_DATA = 'IMPORT_CATALOG_SET_XML_DATA';
export const IMPORT_CATALOG_SET_FILES = 'IMPORT_CATALOG_SET_FILES';
export const IMPORT_CATALOG_SET_ADDITIONAL_FILES = 'IMPORT_CATALOG_SET_ADDITIONAL_FILES';
export const IMPORT_CATALOG_SET_FILE_DATA = 'IMPORT_CATALOG_SET_FILE_DATA';
export const IMPORT_CATALOG_SET_GROUP_DATA = 'IMPORT_CATALOG_SET_GROUP_DATA';
export const IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUP_RAW_DATA = 'IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUP_RAW_DATA';
export const IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUPS = 'IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUPS';
export const IMPORT_CATALOG_SET_ERROR = 'IMPORT_CATALOG_SET_ERROR';

/**
 Шаблоны импорта
 */
export const IMPORT_CATALOG_FETCH_ALL_TEMPLATES_START = 'IMPORT_CATALOG_FETCH_ALL_TEMPLATES_START';
export const IMPORT_CATALOG_FETCH_ALL_TEMPLATES_SUCCESS = 'IMPORT_CATALOG_FETCH_ALL_TEMPLATES_SUCCESS';
export const IMPORT_CATALOG_TEMPLATE_OPERATION_FAIL = 'IMPORT_CATALOG_TEMPLATE_OPERATION_FAIL';
export const IMPORT_CATALOG_SET_SELECTED_TEMPLATE_ID = 'IMPORT_CATALOG_SET_SELECTED_TEMPLATE_ID';
export const IMPORT_CATALOG_DELETE_TEMPLATE_SUCCESS = 'IMPORT_CATALOG_DELETE_TEMPLATE_SUCCESS';
export const IMPORT_CATALOG_SET_IMPORT_WITH_TEMPLATES_STATUS = 'IMPORT_CATALOG_SET_IMPORT_WITH_TEMPLATES_STATUS';
export const IMPORT_CATALOG_SET_XML_TEMPLATE_CONFIG = 'IMPORT_CATALOG_SET_XML_TEMPLATE_CONFIG';
export const IMPORT_CATALOG_SET_TEMPLATE_SAVE_BLOCK = 'IMPORT_CATALOG_SET_TEMPLATE_SAVE_BLOCK';

export const importCatalogClear = () => ({
  type: IMPORT_CATALOG_CLEAR,
  payload: null
});

export const importCatalogSetCurrentStep = (payload) => ({
  type: IMPORT_CATALOG_SET_CURRENT_STEP,
  payload
});

export const importCatalogSetDetectBackStep = (payload) => ({
  type: IMPORT_CATALOG_SET_DETECT_BACK_STEP,
  payload
});

export const importCatalogSetFile = (payload) => ({
  type: IMPORT_CATALOG_SET_FILE,
  payload
});

export const importCatalogUpdateTableData = (payload) => ({
  type: IMPORT_CATALOG_UPDATE_TABLE_DATA,
  payload
});

export const importCatalogSetInfoData = (payload) => ({
  type: IMPORT_CATALOG_SET_INFO_DATA,
  payload
});

export const importCatalogSetOutputConfig = (payload) => ({
  type: IMPORT_CATALOG_SET_OUTPUT_CONFIG,
  payload
});

export const importCatalogSetImportConfig = (payload) => ({
  type: IMPORT_CATALOG_SET_IMPORT_CONFIG,
  payload
});

export const importCatalogSetImportConfigGroups = (payload) => ({
  type: IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUPS,
  payload
});

export const importCatalogSetImportConfigGroupRawData = (payload) => ({
  type: IMPORT_CATALOG_SET_IMPORT_CONFIG_GROUP_RAW_DATA,
  payload
});

export const importCatalogInitWorker = (payload) => ({
  type: IMPORT_CATALOG_INIT_WORKER,
  payload
});

export const importCatalogSetWorkerStatus = (payload) => ({
  type: IMPORT_CATALOG_SET_WORKER_STATUS,
  payload
});

export const importCatalogSetProgress = (payload) => ({
  type: IMPORT_CATALOG_UPDATE_PROGRESS,
  payload
});

export const importCatalogSetXmlStructure = (payload) => ({
  type: IMPORT_CATALOG_SET_XML_STRUCTURE,
  payload
});

export const importCatalogSetXmlParsedData = (payload) => ({
  type: IMPORT_CATALOG_SET_XML_PARSED_DATA,
  payload
});

export const importCatalogSetFiles = (payload) => ({
  type: IMPORT_CATALOG_SET_FILES,
  payload
});

export const importCatalogSetAdditionalFiles = (payload) => ({
  type: IMPORT_CATALOG_SET_ADDITIONAL_FILES,
  payload
});

export const importCatalogSetFileData = (payload) => ({
  type: IMPORT_CATALOG_SET_FILE_DATA,
  payload
});

export const importCatalogSetXmlData = (payload) => ({
  type: IMPORT_CATALOG_SET_XML_DATA,
  payload
});

export const importCatalogSetGroupData = (payload) => ({
  type: IMPORT_CATALOG_SET_GROUP_DATA,
  payload
});


export const importCatalogFetchTemplatesStart = () => ({
  type: IMPORT_CATALOG_FETCH_ALL_TEMPLATES_START
});

export const importCatalogFetchTemplatesSuccess = (data) => ({
  type: IMPORT_CATALOG_FETCH_ALL_TEMPLATES_SUCCESS,
  payload: data
});

export const importCatalogTemplateOperationFail = (error) => ({
  type: IMPORT_CATALOG_TEMPLATE_OPERATION_FAIL,
  payload: error
});

export const importCatalogSetSelectedTemplateId = (payload) => ({
  type: IMPORT_CATALOG_SET_SELECTED_TEMPLATE_ID,
  payload
});

export const importCatalogSetError = (payload) => ({
  type: IMPORT_CATALOG_SET_ERROR,
  payload
});


export const importCatalogDeleteTemplateSuccess = () => ({
  type: IMPORT_CATALOG_DELETE_TEMPLATE_SUCCESS
});

export const importCatalogSetImportWithTemplatesStatus = (payload) => ({
  type: IMPORT_CATALOG_SET_IMPORT_WITH_TEMPLATES_STATUS,
  payload
});

export const importCatalogSetXmlTemplateConfig = (payload) => ({
  type: IMPORT_CATALOG_SET_XML_TEMPLATE_CONFIG,
  payload
});

export const importCatalogSetTemplateSaveBlock = (payload) => ({
  type: IMPORT_CATALOG_SET_TEMPLATE_SAVE_BLOCK,
  payload
});


export const importCatalogFetchTemplates = () => async (dispatch) => {
  try {
    dispatch(importCatalogFetchTemplatesStart());
    const result = await get('/import/catalog-templates');
    dispatch(importCatalogFetchTemplatesSuccess(result?.data?.items || []));
  } catch (e) {
    dispatch(importCatalogTemplateOperationFail(e));
  }
};

export const importCatalogAddTemplate = (data, translations) => async (dispatch) => {
  try {
    await post('/import/catalog-templates', data);
    dispatch(importCatalogFetchTemplates());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    dispatch(importCatalogTemplateOperationFail(e));
    return false;
  }
};

export const importCatalogDeleteTemplate = (id, translations) => async (dispatch) => {
  try {
    await remove(`/import/catalog-templates/${id}`);
    dispatch(importCatalogFetchTemplates());
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    dispatch(importCatalogTemplateOperationFail(e));
  }
};

export const stopImport = () => async () => {
  try {
    await clientApi2.post('/import/stop', {});
    return true;
  } catch (e) {
    return false;
  }
};
